import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "action"
    }}>{`Action`}</h1>
    <p>{`Represents an action in the Actions palette.
Actions are series of commands that can be recorded by user, and can be replayed at a later time`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The internal ID of this action  Can be used for batchPlay calls, used internally`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`index`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`0-index of this action in it`}{`'`}{`s parent action set`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-write`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name of this action, displayed in the panel Cannot be changed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/actionset/"
            }}><em parentName="a">{`ActionSet`}</em></a></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The action set this action belongs to`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The class name of the referenced Action object`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "delete"
    }}>{`delete`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Deletes this action from the actions panel`}</p>
    <hr></hr>
    <h3 {...{
      "id": "duplicate"
    }}>{`duplicate`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/action/"
      }}><em parentName="a">{`Action`}</em></a></p>
    <p>{`Creates a copy of this action, placing it in the same action set`}</p>
    <hr></hr>
    <h3 {...{
      "id": "play"
    }}>{`play`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<void`}{`>`}</p>
    <p>{`Plays this action`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      